import React, { useState } from 'react';
import './GrailContent.css';

function SoundVideo({ id }) {
  const [playing, setPlaying] = useState(false);
  return <div className="grail-video">{playing
    ? <iframe title="GRAIL Soundvideo" src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1`} allow="autoplay; encrypted-media; fullscreen" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />
    : <button type="button" onClick={() => setPlaying(true)}>▶ Soundvideo laden<span>Beim Laden wird eine Verbindung zu YouTube hergestellt.</span></button>}
  </div>;
}

export default function GrailContent({ content, sanitize }) {
  const videos = (content?.videos || []).filter(v => v.provider === 'youtube' && /^[A-Za-z0-9_-]{11}$/.test(v.id));
  return <section className="grail-content" aria-label="GRAIL Produktinformationen">
    <div className="grail-technical-card"><h2>Produktbeschreibung</h2>
      <div className="grail-description" dangerouslySetInnerHTML={{ __html: sanitize(content?.description_html || '<p>Bitte eine Ausführung wählen, um die zugehörigen Produktinformationen zu sehen.</p>') }} />
    </div>
    {videos.length > 0 && <div className="grail-technical-card"><h3>Sound &amp; Produktvideos</h3>{videos.map(v => <SoundVideo key={v.id} id={v.id} />)}</div>}
  </section>;
}
